module.exports = __webpack_public_path__ + "static/media/image.b10b5f05.svg";